'use client';

import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const CagrGraph = ({
  baseValue,
  highValue,
  valueenv,
  baseYear,
  forecastedYear,
}) => {
  const chartData = {
    labels: [baseYear, forecastedYear],
    datasets: [
      {
        label: `USD ${valueenv}`,
        data: [baseValue, highValue],
        backgroundColor: ['#6196ac', '#6196ac'],
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 50,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        display: false,
        grid: {
          display: false,
          offset: true,
        },
      },
    },
    plugins: {
      datalabels: {
        display: true, // Display labels
        color: 'black', // Text color
        anchor: 'end', // Positioning anchor point
        align: 'top', // Text alignment
        borderRadius: 5, // Border radius
        formatter: (value) => {
          const numericValue = Number(value);
          const formattedValue = numericValue.toLocaleString();
          return `USD ${formattedValue} ${valueenv}`; // Formatting function
        },
        font: {
          size: 5, // Font size
          weight: 'medium', // Font weight
        },
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        displayColors: false, // Don't display the color box next to the label text
        xAlign: 'center', // Center the tooltip horizontally
        yAlign: 'bottom', // Place the tooltip below the bar
      },
    },
    // onLoad: (chart) => {
    //     applyGradient(chart);
    // },
  };

  return <Bar data={chartData} options={options} />;
};

export default CagrGraph;
